import { GIPIUuid } from "@gipisistemas/ng-core";

export class FinancialCreditClientCancelDTO {

    /** @Required Id do turno do caixa  */
    cashierShiftId: GIPIUuid;

    /** @Required Id do crédito do cliente a ser cancelado */
    creditClientId: GIPIUuid;

    /** @Required Descrição */
    description: string;

    /** @Required Id da categoria */
    postingCategoryId: GIPIUuid;

}
